export default {"src":"/_next/static/media/exmo.3094c149.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};